import { Badge, Tooltip } from "@mantine/core";
import { useCallback } from "react";
import {
  StainMarkerVerificationSummary,
  StainMarkerVerificationStatus,
} from "../../../services/admin/stains.service";
import { StainMarkerVerificationTooltip } from "./StainMarkerVerificationTooltip";

interface Props {
  summary: StainMarkerVerificationSummary | null | undefined;
}

const STATUS_COLORS: Record<StainMarkerVerificationStatus, string> = {
  pending: "gray",
  sent: "blue",
  accepted: "green",
  rejected: "orange",
  failed: "red",
  timed_out: "red",
  dry_run: "blue",
};

export default function StainMarkerVerificationProviderBadge({
  summary,
}: Props) {
  const getLabel = useCallback((status: StainMarkerVerificationStatus) => {
    if (status === "accepted") return "Verified";
    if (
      status === "rejected" ||
      status === "failed" ||
      status === "timed_out"
    ) {
      return "Failed";
    }
    return status.replace("_", " ");
  }, []);

  if (!summary) {
    return (
      <Badge color="gray" variant="dot" size="xs">
        Untested
      </Badge>
    );
  }

  const label = getLabel(summary.status);
  const color = STATUS_COLORS[summary.status];

  return (
    <Tooltip
      label={<StainMarkerVerificationTooltip summary={summary} />}
      withArrow
      multiline
    >
      <Badge color={color} variant="light" size="xs" style={{ cursor: "help" }}>
        {label}
      </Badge>
    </Tooltip>
  );
}
